














import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class KanbanBoard extends Vue {
  @Prop({ type: String, required: true }) title!: string;
  @Prop({ type: Number, default: 0 }) itemCount!: number;
  @Prop({ type: Number, default: 0 }) order!: number;
}
